import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import * as merchandiseStyles from "../../styles/world_championships/Merchandise.module.css"

const Merchandise = props => {
  const { content } = props

  const subtitle = ChildSelector.select(
    content,
    `subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const invite = ChildSelector.select(
    content,
    `invite`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const picturesList = ChildSelector.select(
    content,
    `merc-pictures`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )
  const pictures =
    (picturesList &&
      picturesList.childNodes.map((pic, idx) => {
        return { childNodes: [pic] }
      })) ||
    []

  return (
    <div className="container-fluid">
      <div className={`row g-0 ${merchandiseStyles.wrapper}`}>
        <div className={`col-12`}>
          <div className={`row g-0`}>
            <div className={`col-12 ${merchandiseStyles.heading}`}>
              <h3>{subtitle}</h3>
              <h2>{title}</h2>
              <h5>{invite}</h5>
            </div>
          </div>

          <div className={`row g-0`}>
            <div className={`col-12 ${merchandiseStyles.content}`}>
              <div className={`row g-0 ${merchandiseStyles.imageWall}`}>
                {pictures.map((pic, idx) => (
                  <div
                    key={idx}
                    className={`col-12 col-md-4 ${merchandiseStyles.imageWrapper}`}
                  >
                    <a href="https://cubewisemerchshop.squarespace.com" rel="noreferrer noopener" target="_blank">
                      <WPImage
                        holder={pic}
                        selector={`wp-block-image`}
                        mode={DISPLAY_MODE.normal}
                        className={`${merchandiseStyles.mercImage}`}
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Merchandise
